// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2rkolb4i{border-radius:var(--ds-radius-xsmall,2px)}\n._bfhkhp5a{background-color:var(--ds-surface-raised,#fff)}\n._irr3116u:hover{background-color:var(--ds-surface-raised-hovered,#f0f1f2)}", ""]);
// Exports
module.exports = exports;
